﻿import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { styled } from "@mui/system";
import { SearchIcon } from "@/ImageRepo";

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--grey-light)",
    },
    "&:hover fieldset": {
      borderColor: "var(--primary-main)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-main)",
    },
  },
});

const ShepSearchBar = (props) => {
  return (
    <CustomTextField
      {...props}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon width="18" height="18" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ShepSearchBar;
